const searchToggles = document.querySelectorAll(".search-bar__toggle");
const searchModal = document.getElementById("search-modal");

if (searchToggles) {
	Array.from(searchToggles).map((searchToggle) => {
		searchToggle.addEventListener("click", () => {
			if (searchModal.open) {
				searchModal.close();
				return;
			}
			searchModal.showModal();
		});
	});
}
